import React, { Component } from 'react';

//import updateWorkplace from '../../../images/icons/updateWorkplace.png';
import { Tooltip } from 'devextreme-react/tooltip';

//import * as updateWorkplace from "../../../images/icons/Refresh.svg";
import * as collapseRightArea from "../../../../images/icons/collapseRight.svg";



class CollapseRightArea extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            //defaultVisible: false,
            withAnimationVisible: false,
            //withTemplateVisible: false
        };

        this.toggleWithAnimation = this.toggleWithAnimation.bind(this);

    }

    render() {

        return (
            <div>
                <img
                    id="product5"
                    onMouseEnter={this.toggleWithAnimation}
                    onMouseLeave={this.toggleWithAnimation}
                    style={{ height: '16px', width: '16px', zIndex: 10, color: "#fff", marginTop: '-16px', marginLeft: '21px' }}
                    src={collapseRightArea} />
                <Tooltip
                    target="#product5"
                    position="top"
                    //animation={animationConfig}
                    visible={this.state.withAnimationVisible}
                    closeOnOutsideClick={false}
                >
                    <div>Collapse Panel</div>
                </Tooltip>
            </div>
        );
    }
    toggleWithAnimation() {
        this.setState({
            withAnimationVisible: !this.state.withAnimationVisible
        });
    }
}
export default CollapseRightArea;





// WEBPACK FOOTER //
// ./src/components/TaskView/SideDraw/Task/CollapseRightArea.js